import { render, staticRenderFns } from "./Importaciones.vue?vue&type=template&id=00115f2c"
import script from "./Importaciones.vue?vue&type=script&lang=js"
export * from "./Importaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports